import Image from '@tiptap/extension-image';
import { imageApi } from '../services/imageApi';

/**
 * Custom TipTap Image extension that fetches authenticated images.
 * URLs containing "/extracted-images/" are fetched via the authenticated
 * apiClient and displayed as blob URLs. Uses a vanilla JS NodeView
 * to avoid React lifecycle overhead during editor initialization.
 */
export const AuthenticatedImage = Image.extend({
  addNodeView() {
    return ({ node }) => {
      const src: string = node.attrs.src || '';
      const alt: string = node.attrs.alt || '';
      const title: string = node.attrs.title || '';
      const needsAuth = src.includes('/extracted-images/');

      const img = document.createElement('img');
      img.className = 'report-image';
      img.alt = alt;
      img.title = title;

      if (needsAuth) {
        // Placeholder styling while loading
        img.style.minHeight = '200px';
        img.style.background = '#f3f4f6';
        img.style.borderRadius = '0.5rem';
        img.style.display = 'block';

        imageApi
          .fetchImageBlob(src)
          .then((blob) => {
            const blobUrl = URL.createObjectURL(blob);
            img.src = blobUrl;
            img.style.minHeight = '';
            img.style.background = '';
          })
          .catch(() => {
            img.alt = 'Failed to load image';
            img.style.minHeight = '60px';
            img.style.background = '#f3f4f6';
          });
      } else {
        img.src = src;
      }

      return {
        dom: img,
        update: (updatedNode) => {
          if (updatedNode.type.name !== 'image') return false;
          const newSrc = updatedNode.attrs.src || '';
          img.alt = updatedNode.attrs.alt || '';
          img.title = updatedNode.attrs.title || '';

          if (newSrc !== src && !newSrc.includes('/extracted-images/')) {
            img.src = newSrc;
          }
          return true;
        },
        destroy: () => {
          if (img.src.startsWith('blob:')) {
            URL.revokeObjectURL(img.src);
          }
        },
      };
    };
  },
});
